export const validEmail = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
export const validNumber = /^(\+\d{1,3}[- ]?)?\d{10}$/;